<template>
  <!-- Тёмная плашка над лентой (p4, p5): кто ведёт обращение и категория -->
  <div class="specialist-plate">
    <support-avatar
      v-if="appeal.assignee"
      :src="appeal.assignee.avatar"
      :name="appeal.assignee.name"
      :size="32"
    />
    <span v-else class="specialist-plate__unknown">?</span>
    <div class="specialist-plate__text">
      <div class="specialist-plate__name">
        {{ title }}
      </div>
      <div class="specialist-plate__sub">
        {{ subtitle }}
      </div>
    </div>
    <category-chip :category="appeal.category" white />
  </div>
</template>

<script>
  import CategoryChip from '../CategoryChip.vue'
  import SupportAvatar from '../SupportAvatar.vue'
  import { clock, rowTime } from '../format'
  import { isClosed } from '../status'

  export default {
    name: 'SpecialistPlate',
    components: { CategoryChip, SupportAvatar },
    props: {
      appeal: { type: Object, required: true },
    },
    computed: {
      title () {
        return this.appeal.assignee ? `${this.appeal.assignee.name} · поддержка FAKT` : 'Поддержка FAKT'
      },
      subtitle () {
        const number = `№${this.appeal.number}`
        // Никто ещё не взял: обещаем подключение, а не имя (Q29 - «изучаем»).
        if (!this.appeal.assignee) return `изучаем ваше обращение ${number}`
        if (isClosed(this.appeal) && this.appeal.resolvedAt) {
          return `вёл ваше обращение ${number} · закрыл ${this.closedAt}`
        }

        return `ведёт ваше обращение ${number}${this.appeal.assignee.isOnline ? ' · на линии' : ''}`
      },
      // «сегодня в 10:21», «вчера в 18:40», «14 сент в 10:21»
      closedAt () {
        const day = rowTime(this.appeal.resolvedAt).split(',')[0]

        return `${day} в ${clock(this.appeal.resolvedAt)}`
      },
    },
  }
</script>

<style scoped lang="less">
@import '../tokens.less';

.specialist-plate {
  display: flex;
  flex-shrink: 0;
  gap: 12px;
  align-items: center;
  min-height: 56px;
  padding: 8px 12px 8px 8px;
  border-radius: 4px;
  background: @fakt-chat-header;
}

.specialist-plate__unknown {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 500;
  color: @fakt-text-3;
  background: @fakt-surface;
}

.specialist-plate__text {
  flex: 1;
  min-width: 0;
}

.specialist-plate__name {
  font-size: 16px;
  font-weight: 500;
  color: @fakt-white;
}

.specialist-plate__sub {
  font-size: 12px;
  color: @fakt-on-dark-muted;
}
</style>
